import { useState } from "react";
import SvgIcn from "../../data/IconCompo";
import "../../styles/atoms.scss";

const CheckBtn = ({ onChange,label, iconOn, iconOff, disabled, checked }) => {


    const handleClick = () => {
        if (disabled && !checked) return;

        onChange?.(label,!checked);
    };

    return (
        <div
            className={`checkbtn-hero ${checked ? "checked" : ""} ${disabled && !checked ? "disabled" : ""}`}
            onClick={handleClick}
        >
            <SvgIcn name={checked ? iconOn : iconOff} />
        </div>
    );
};

export default CheckBtn;